import React, { useState, useCallback } from 'react'
import BrokeragePayerScopeSection from 'components/BatchPayments/brokeragePayerScopeSection'
import PaymentSection from 'components/BatchPayments/PaymentSection'
import PaymentOrders from 'components/BatchPayments/PaymentOrders'

export default function AgentBatchPayment() {
  const [ordersData, setOrdersData] = useState<any[]>([]);
  const [showPaymentComponents, setShowPaymentComponents] = useState(false);
  const [selectedCount, setSelectedCount] = useState(0);
  const [selectedBalance, setSelectedBalance] = useState(0);
  const [selectedOrders, setSelectedOrders] = useState<any[]>([]);
  const [selectedVendor, setSelectedVendor] = useState<any>(null);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [scopeData, setScopeData] = useState({
    scope: "agent",
    company: "",
    teamMembers: [] as string[],
    offices: [] as string[],
    agents: [] as string[],
    bill_from: "",
    bill_to: ""
  });

  const handleOrdersFetched = useCallback((data: {
    orders: any[];
    total: number;
    totalPages: number;
    page: number;
    limit: number;
  }) => {
    setOrdersData(data.orders);
    setTotalCount(data.total);
    setTotalPages(data.totalPages);
    setShowPaymentComponents(true);
    
    // Initialize with empty selection
    setSelectedBalance(0);
    setSelectedCount(0);
    setSelectedOrders([]);
    
    // Update pagination to match the fetched page
    setPagination({ pageIndex: data.page - 1, pageSize: data.limit });
  }, []);

  const handleOrderSelectionChange = useCallback((selection: {
    count: number;
    totalBalance: number;
    orders: any[];
  }) => {
    console.log('Order selection changed:', selection);
    setSelectedCount(selection.count);
    setSelectedBalance(selection.totalBalance);
    setSelectedOrders(selection.orders);
  }, []);

  const handleVendorChange = useCallback((vendor: any) => {
    console.log('Vendor changed:', vendor);
    setSelectedVendor(vendor);
  }, []);

  const handleScopeDataChange = useCallback((data: {
    scope: string;
    company: string;
    teamMembers: string[];
    offices: string[];
    agents: string[];
    bill_from: string;
    bill_to: string;
  }) => {
    console.log('Scope data changed:', data);
    setScopeData(data);
  }, []);

  return (
    <>
    <div className="container-fluid">
        <div className="row">
            <div className="col-lg-12 mb-4">
                <h2>Batch Payments</h2>
                <p className='mb-0'>Process payments for multiple orders efficiently</p>
            </div>
            <BrokeragePayerScopeSection 
              onOrdersFetched={handleOrdersFetched} 
              onVendorChange={handleVendorChange}
              onScopeDataChange={handleScopeDataChange}
              pagination={pagination}
              onPaginationReset={() => setPagination({ pageIndex: 0, pageSize: 10 })}
              selectedOrdersForReport={selectedOrders}
            />
            
            {showPaymentComponents && (
              <>
                <PaymentSection
                    selectedCount={selectedCount}
                    selectedBalance={selectedBalance}
                    selectedOrders={selectedOrders}
                    allocatedAmount={selectedBalance}
                    remainingAmount={0}
                    defaultEmailReceipt={true}
                    defaultMethod="card"
                    selectedVendor={selectedVendor}
                    scope={scopeData.scope}
                    company={scopeData.company}
                    teamMembers={scopeData.teamMembers}
                    offices={scopeData.offices}
                    agents={scopeData.agents}
                    bill_from={scopeData.bill_from}
                    bill_to={scopeData.bill_to}
                    onPostPayment={(payload) => {
                        console.log('Payment posted:', payload);
                        // Handle payment posting here
                    }}
                    onPaymentSuccess={() => {
                        console.log('Payment successful!');
                        // Handle successful payment (e.g., refresh data, show success message)
                        // You can call the orders fetch again or update the UI
                    }}
                />
                <PaymentOrders 
                  ordersData={ordersData} 
                  onSelectionChange={handleOrderSelectionChange}
                  pagination={pagination}
                  onPaginationChange={setPagination}
                  totalCount={totalCount}
                  totalPages={totalPages}
                />
              </>
            )}
        </div>
    </div>
    </>
  )
}
